// ERP texts, one file per area (merged under the "erp" key: t('erp.customers.title')).
import automation from './automation'
import commercial from './commercial'
import common from './common'
import crm from './crm'
import diagnoses from './diagnoses'
import finance from './finance'
import granola from './granola'
import hours from './hours'
import monthly from './monthly'
import projects from './projects'
import reports from './reports'
import support from './support'

export default { ...common, ...crm, ...automation, ...projects, ...finance, ...commercial, ...support, ...monthly, ...reports, ...hours, ...diagnoses, ...granola }
